/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { PropertyMatrixBaseService } from '../property-matrix-base-service';
import { PropertyMatrixConfiguration } from '../property-matrix-configuration';
import { PropertyMatrixStrictHttpResponse } from '../property-matrix-strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ValuerFormVm } from '../models/valuer-form-vm';

@Injectable({
  providedIn: 'root',
})
export class ValuerService extends PropertyMatrixBaseService {
  constructor(
    config: PropertyMatrixConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiV1ValuerSaveValuerDetailsPost
   */
  static readonly ApiV1ValuerSaveValuerDetailsPostPath = '/api/v1/Valuer/SaveValuerDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ValuerSaveValuerDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1ValuerSaveValuerDetailsPost$Response(params?: {
    context?: HttpContext
    body?: ValuerFormVm
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ValuerService.ApiV1ValuerSaveValuerDetailsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ValuerSaveValuerDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1ValuerSaveValuerDetailsPost(params?: {
    context?: HttpContext
    body?: ValuerFormVm
  }
): Observable<void> {

    return this.apiV1ValuerSaveValuerDetailsPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

}
